import { DOC_CODE_RE, type DocMeta, newDocPrefixes } from "@klarity/schema";
import type { DocKind } from "./api/models";

export type MetaErrors = Partial<Record<keyof DocMeta, string>>;

/** C4's code rule, from the schema package (codes are unique case-insensitively on the server). */
export const CODE_RE = DOC_CODE_RE;
const DATE_RE = /^\d{4}-(0[1-9]|1[0-2])(-(0[1-9]|[12]\d|3[01]))?$/;
const blank = (v: string | undefined) => v === undefined || v.trim() === "";

/** C4 rules, phrased so a person can act on them. The server validates again (400 invalid_meta). */
export function validateMeta(kind: DocKind, meta: DocMeta): MetaErrors {
  const e: MetaErrors = {};
  if (kind === "page") {
    if (!blank(meta.code)) e.code = "Wiki pages have no code.";
    return e;
  }
  if (kind === "document") {
    if (blank(meta.code)) e.code = "Enter a document code, for example RB-Tenant-Onboarding.";
    if (blank(meta.subtitle)) e.subtitle = "Enter a subtitle.";
    if (blank(meta.docType)) e.docType = "Enter a document type, for example Runbook.";
  }
  if (!blank(meta.code) && !CODE_RE.test(meta.code?.trim() ?? "")) {
    e.code = `Codes start with ${newDocPrefixes("-")}, followed by letters, digits and dashes.`;
  }
  if (meta.audience === "client" && blank(meta.client)) e.client = "Enter the client's name.";
  if (!blank(meta.date) && !DATE_RE.test(meta.date?.trim() ?? "")) e.date = "Use YYYY-MM or YYYY-MM-DD.";
  return e;
}

export function cleanMeta(meta: DocMeta): DocMeta {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(meta)) {
    if (typeof v === "string") {
      if (v.trim() !== "") out[k] = v.trim();
    } else if (v !== undefined) out[k] = v;
  }
  return out as DocMeta;
}
